import { application } from '@elab/core/utils/appData';

const getBaseUri = () => `${application.occBaseUri}/${application.baseSiteId}`;

const defaultSearchParamsFilter = ([, value]) => Boolean(value);

function buildSearchString(params, filter = defaultSearchParamsFilter) {
    return Object.entries(params)
        .filter(filter)
        .reduce((result, [name, value]) => {
            result.append(name, value);

            return result;
        }, new URLSearchParams())
        .toString();
}

const getCountry = () => application.country;

export default {
    getBaseUri,
    buildSearchString,
    getCountry,
};
